import { findBreakpointSettings } from "./../composables/useBreakpoints.js";
function updateStyles(el, binding) {
  const slice = binding.value.slice;
  const field = binding.value.field;
  const breakpointSettings = findBreakpointSettings(
    slice.fields[field].properties
  );
  if (breakpointSettings) {
    if (breakpointSettings.font)
      el.style.fontFamily = breakpointSettings.font;
    if (breakpointSettings.fontSize) {
      if (/^\d+$/.test(breakpointSettings.fontSize)) {
        el.style.fontSize = `${breakpointSettings.fontSize}px`;
      } else {
        if (breakpointSettings.fontSize)
          el.style.fontSize = breakpointSettings.fontSize;
        else
          el.style.removeProperty("font-size");
      }
    }
    if (breakpointSettings.fontWeight) {
      if (breakpointSettings.fontWeight)
        el.style.fontWeight = breakpointSettings.fontWeight;
      else
        el.style.removeProperty("font-weight");
    }
    if (breakpointSettings.letterSpacing) {
      if (/^\d+$/.test(breakpointSettings.letterSpacing)) {
        el.style.letterSpacing = `${breakpointSettings.letterSpacing}px`;
      } else {
        if (breakpointSettings.letterSpacing)
          el.style.letterSpacing = breakpointSettings.letterSpacing;
        else
          el.style.removeProperty("letter-spacing");
      }
    }
    if (breakpointSettings.lineHeight) {
      if (/^\d+$/.test(breakpointSettings.lineHeight)) {
        el.style.lineHeight = `${breakpointSettings.lineHeight}px`;
      } else {
        if (breakpointSettings.lineHeight)
          el.style.lineHeight = breakpointSettings.lineHeight;
        else
          el.style.removeProperty("line-height");
      }
    }
    if (breakpointSettings.textAlign) {
      if (breakpointSettings.textAlign)
        el.style.textAlign = breakpointSettings.textAlign;
      else
        el.style.removeProperty("text-align");
    }
    if (breakpointSettings.columns)
      el.style.columns = breakpointSettings.columns.toString();
  }
}
const vVoixText = {
  // called before bound element's attributes
  // or event listeners are applied
  mounted(el, binding) {
    if (binding.value.slice && binding.value.field) {
      updateStyles(el, binding);
      window.addEventListener("resize", () => updateStyles(el, binding));
    }
  },
  updated(el, binding) {
    if (binding.value.slice && binding.value.field)
      updateStyles(el, binding);
  }
};
export default vVoixText;
